import api from "@/utils/axios";

const OUTLET_API_URL = `/outlets`;

export default {
  namespaced: true,
  state: {
    outlets: [],
    outlet: null,
    loading: false,
    error: null,
  },
  mutations: {
    SET_OUTLETS(state, outlets) {
      state.outlets = outlets;
    },
    SET_OUTLET(state, outlet) {
      state.outlet = outlet;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },
  actions: {
    async fetchOutlet({ commit }, outletId) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const response = await api.get(`${OUTLET_API_URL}/${outletId}/`);
        commit("SET_OUTLET", response.data.data);
      } catch (error) {
        commit(
          "SET_ERROR",
          error.response?.data?.error || "Failed to fetch outlet"
        );
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchOutlets({ commit }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const response = await api.post(`${OUTLET_API_URL}/filter/`);
        commit("SET_OUTLETS", response.data.data);
      } catch (error) {
        commit(
          "SET_ERROR",
          error.response?.data?.error || "Failed to fetch outlets"
        );
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async createOutlet({ commit, dispatch }, payload) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        await api.post(`${OUTLET_API_URL}/new/`, payload);
        dispatch("fetchOutlets");
      } catch (error) {
        commit(
          "SET_ERROR",
          error.response?.data?.error || "Failed to create outlet"
        );
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async updateOutlet({ commit, dispatch }, { outletId, payload }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        await api.patch(`${OUTLET_API_URL}/${outletId}/`, payload);
        dispatch("fetchOutlet", outletId);
      } catch (error) {
        commit(
          "SET_ERROR",
          error.response?.data?.error || "Failed to update outlet"
        );
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async deleteOutlet({ commit, dispatch }, outletId) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        await api.delete(`${OUTLET_API_URL}/${outletId}/`);
        dispatch("fetchOutlets");
      } catch (error) {
        commit(
          "SET_ERROR",
          error.response?.data?.error || "Failed to delete outlet"
        );
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
  getters: {
    outlets: (state) => state.outlets,
    outlet: (state) => state.outlet,
    outletLoading: (state) => state.loading,
    outletError: (state) => state.error,
  },
};
